import {
  getWorkInfo,
  getQuestionList,
  getQuestionInfo,
  submitWork,
  submitWorkTask,
  markerQuestion,
  answerQuestion,
} from "@saas/service-api/src/homework/index";
import {
  WORK_STATUS,
  QUESTION_TYPE_NAME,
} from "@saas/components/src/constants/question";
import { MessageBox } from "element-ui";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { customMessage } from "@saas/components/src/plugins/custom-config.js";
import router from "@/router/index.js";

const state = {
  workId: "",
  userId: "", // 查看某个用户的id
  taskId: "",
  activityId: "", // 打卡活动id
  workInfo: {},
  questionList: [],
  startAnswer: false, //开始作答
  questionInfoList: [], //所有题目信息
  isCorrected: false, //是否已批改
  showAnswerReport: false, //是否显示答题报告
  showErrorAnalysis: false,
  activeIndex: 0,
  isMobile: false,
  errorQuestionList: [],
  isClockIn: false, // 是否是打卡作业
};

const mutations = {
  setIsClockIn: (state, bool) => {
    state.isClockIn = bool;
  },
  setWorkId: (state, id) => {
    state.workId = Number(id);
  },
  setUserId: (state, id) => {
    state.userId = id ? Number(id) : "";
  },
  setTaskId: (state, id) => {
    state.taskId = Number(id);
  },
  setActivityId: (state, id) => {
    state.activityId = id ? Number(id) : 0;
  },
  setWorkInfo: (state, obj) => {
    state.workInfo = obj || {};
  },
  setQuestionList: (state, arr) => {
    state.questionList = arr || [];
  },
  setQuestionInfo: (state, obj) => {
    state.questionInfo = obj || {};
  },
  setStartAnswer: (state, bool) => {
    state.startAnswer = bool;
  },
  setQuestionInfoList: (state, arr) => {
    state.questionInfoList = arr || [];
  },
  updateQuestionList: (state, obj) => {
    let { index, key, value } = obj;
    state.questionList[index][key] = value;
    state.questionList = [...state.questionList];
  },
  setIsCorrected: (state, bool) => {
    state.isCorrected = bool;
  },
  setShowAnswerReport: (state, bool) => {
    state.showAnswerReport = bool;
  },
  setShowErrorAnalysis: (state, bool) => {
    state.showErrorAnalysis = bool;
  },
  updateQuestionInfoList: (state, obj) => {
    let { subIndex, pidIndex, key, value } = obj;
    if (subIndex !== undefined) {
      state.questionInfoList[pidIndex].child[subIndex][key] = value;
    } else {
      state.questionInfoList[pidIndex][key] = value;
    }
    state.questionInfoList = JSON.parse(JSON.stringify(state.questionInfoList));
  },
  setActiveIndex: (state, index) => {
    state.activeIndex = index;
  },
  setIsMobile: (state, bool) => {
    state.isMobile = bool;
  },
  setErrorQuestionList: (state, arr) => {
    state.errorQuestionList = arr || [];
    console.log(arr, "arr");
  },
};

const actions = {
  apiGetWorkInfo({ commit, state, dispatch }, { id, taskId, actId }) {
    commit("setWorkId", id);
    commit("setTaskId", taskId);
    commit("setActivityId", actId);
    // 初始化数据
    commit("setWorkInfo", {});
    // commit("setStartAnswer", false);
    commit("setIsCorrected", false);
    commit("setShowAnswerReport", false);
    commit("setShowErrorAnalysis", false);
    commit("setQuestionInfoList", []);
    commit("setQuestionList", []);
    commit("setActiveIndex", 0);
    commit("setErrorQuestionList", []);
    let params = {
      work_id: state.workId,
    };
    if (state.userId) {
      params.user_id = state.userId;
    }
    if (taskId) {
      params.task_id = state.taskId;
    }
    getWorkInfo(params).then((res) => {
      if (res.code === 1) {
        commit("setWorkInfo", res.data);
        if (res?.data?.status === WORK_STATUS.CORRECTED) {
          commit("setIsCorrected", true);
          commit("setShowAnswerReport", true);
          if (!state.isMobile) {
            commit("setStartAnswer", true);
          }
        }
        if (state.isMobile) {
          commit("setStartAnswer", false);
        }
        // 获取题目列表
        dispatch("apiGetQuestionList", {
          id: state.workId,
          taskId: state.taskId,
        });
      } else {
        customMessage({
          message: res.message,
          type: "error",
        });
      }
    });
  },
  apiGetQuestionList(
    { commit, state, dispatch, getters },
    { id, taskId = "" }
  ) {
    commit("setWorkId", id);
    let params = {
      work_id: state.workId,
      user_id: router?.history?.current?.query?.userId,
    };
    if (taskId) {
      params.task_id = taskId;
    }
    getQuestionList(params).then((res) => {
      if (res.code === 1) {
        commit("setQuestionList", res.data);
        if (res.data?.length && state.startAnswer) {
          dispatch("apiGetQuestionInfo", {
            work_id: state.workId,
            question_ids: getters.questionPids.join(","),
          });
        }
      } else {
        customMessage({
          message: res.message,
          type: "error",
        });
      }
    });
  },
  apiGetQuestionInfo({ commit, state, getters }, params) {
    getQuestionInfo({
      ...params,
      user_id: router?.history?.current?.query?.userId,
      task_id: state.taskId,
    }).then((res) => {
      if (res.code === 1) {
        if (res?.data?.length) {
          let info = res.data.map((item, index) => {
            if (item?.child?.length) {
              // 复合题目
              item.child = item.child.map((subItem, subIndex) => {
                return {
                  ...subItem,
                  big_question_type: item.question_type,
                  userAnswer: subItem?.user_answer?.answer || "",
                  subIndex,
                  right: subItem?.user_answer?.right,
                  pidIndex: index,
                };
              });
            }
            return {
              ...item,
              isCompoundQuestion: item?.child?.length,
              userAnswer: item?.user_answer?.answer || "",
              right: item?.user_answer?.right,
              pidIndex: index,
            };
          });
          if (state.showErrorAnalysis) {
            info = info.filter((item) => {
              if (item?.child?.length) {
                // 复合题目
                item.errorChild = item.child.filter((subItem) => {
                  return subItem.right !== 1;
                });
              }
              return (
                (!item.isCompoundQuestion && item.right !== 1) ||
                (item.isCompoundQuestion && item?.errorChild?.length)
              );
            });
          }
          commit("setQuestionInfoList", info);
          commit(
            "setErrorQuestionList",
            state.questionList.filter((item) => !item.is_right)
          );
        }
      } else {
        customMessage({
          message: res.message,
          type: "error",
        });
      }
    });
  },
  // 提交选项
  apiAnswerQuestion({ commit, state, getters }, params) {
    let { work_id, question_pid, question_id, answer, question_type } = params;
    let newParams = {
      work_id,
      question_pid,
      question_id,
      answer,
    };
    if (state.taskId) {
      newParams.task_id = state.taskId;
    }
    answerQuestion(newParams).then((res) => {
      if (res.code === 1) {
        let index = getters?.questionIndexObj[params.question_id];
        commit("updateQuestionList", {
          index,
          key: "is_answer",
          value: Boolean(params.answer),
        });
        // 已答且是单选或判断-自动跳转到下一题
        if (
          Boolean(params.answer) &&
          [QUESTION_TYPE_NAME.SINGLE_CHOICE, QUESTION_TYPE_NAME.JUDGE].includes(
            question_type
          )
        ) {
          if (state.questionList?.[index + 1]) {
            // 有下一题-自动跳转到下一题
            EventBus.$emit(
              `answer-sheet-auto-next-question`,
              state.questionList?.[index + 1]
            );
          } else if (index === state.questionList?.length - 1) {
            //最后一题-进入答题卡界面
            EventBus.$emit(`show-answer-sheet-page`);
          }
        }
      } else {
        customMessage({
          message: res.message,
          type: "error",
        });
      }
    });
  },
  // 标记题目
  apiMarkerQuestion({ commit, state, getters }, params) {
    let {
      work_id,
      question_id,
      is_markers,
      subIndex,
      pidIndex,
      errorPidIndex,
      errorSubIndex,
    } = params;
    markerQuestion({
      work_id,
      question_id,
      is_markers,
    }).then((res) => {
      if (res.code === 1) {
        let pid = getters?.questionIndexObj[params.question_id]?.pid;
        if (state.isMobile && state.showErrorAnalysis) {
          commit("updateQuestionInfoList", {
            subIndex: errorSubIndex,
            pidIndex: errorPidIndex,
            key: "is_markers",
            value: params.is_markers,
          });
        } else {
          commit("updateQuestionInfoList", {
            subIndex,
            pidIndex,
            key: "is_markers",
            value: params.is_markers,
          });
          commit("updateQuestionList", {
            index: state.activeIndex,
            key: "is_markers",
            value: params.is_markers,
          });
        }
      }
    });
  },
  changeQuestionIndex({ commit, state, dispatch, getters }, index) {
    commit("setActiveIndex", index);
    dispatch("apiGetQuestionInfo", {
      work_id: state.workId,
      question_ids: getters.questionId,
    });
  },
  submitAnswer({ dispatch, getters, state }) {
    if (getters?.answeredNum !== state?.questionList?.length) {
      let unAnswerNum = state?.questionList?.length - getters?.answeredNum;
      MessageBox.confirm(`您还有${unAnswerNum}题未作答`, "提示", {
        cancelButtonText: "交卷",
        confirmButtonText: "继续作答",
        customClass: "saas-confirm-message",
        confirmButtonClass: "confirm-btn",
        cancelButtonClass: "cancel-btn",
        closeOnClickModal: false,
        showClose: false,
      })
        .then(() => { })
        .catch(() => {
          // 交卷
          if (state.taskId) {
            dispatch("apiSubmitWorkTask");
          } else {
            dispatch("apiSubmitWork");
          }
        });
    } else {
      MessageBox.confirm(
        "确认提交作业吗？提交后无法变更。<br/>作业批改后可看到相应批改结果。",
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "saas-confirm-message",
          confirmButtonClass: "confirm-btn",
          cancelButtonClass: "cancel-btn",
          showClose: false,
        }
      )
        .then(() => {
          // 交卷
          if (state.taskId) {
            dispatch("apiSubmitWorkTask");
          } else {
            dispatch("apiSubmitWork");
          }
        })
        .catch(() => { });
    }
  },
  apiSubmitWork({ state, dispatch }) {
    let param = {
      work_id: state.workId,
    };
    submitWork(param).then((res) => {
      if (res.code === 1) {
        customMessage({
          message: "提交成功",
          type: "success",
        });
        setTimeout(() => {
          dispatch("apiGetWorkInfo", { id: state.workId });
        }, 1000);
      } else {
        customMessage({
          message: res.message,
          type: "error",
        });
      }
    });
  },
  /**
   * 小程序提交作业打卡
   * */
  apiSubmitWorkTask({ commit, state, dispatch }) {
    let param = {
      task_id: state.taskId,
      activity_id: state.activityId,
      user_work_id: state.workId,
    };
    submitWorkTask(param).then((res) => {
      if (res.code === 1) {
        commit("setWorkInfo", {
          ...state.workInfo,
          status: WORK_STATUS.CORRECTED,
        });
        customMessage({
          message: "提交成功",
          type: "success",
        });
        setTimeout(() => {
          dispatch("apiGetWorkInfo", {
            id: state.workId,
            taskId: state.taskId,
            actId: state.activityId,
          });
        }, 1000);
      } else {
        customMessage({
          message: res.message,
          type: "error",
        });
      }
    });
  },
};

const getters = {
  // 是否展示答题卡入口
  showAnswerSheetBtn: ({ workInfo }) => {
    return workInfo?.status <= 1;
  },
  // 是否过期
  // isExpired: ({ workInfo }) => {
  //   let now = new Date().getTime();
  //   if (workInfo?.work_end_time && workInfo.work_end_time * 1000 < now) {
  //     // 超时
  //     return true;
  //   }
  // },
  // 是否可提交
  canSubmit: ({ workInfo, isClockIn }) => {
    let now = new Date().getTime();
    // 打卡作业不校验超时
    if (
      !isClockIn &&
      workInfo?.work_end_time &&
      workInfo.work_end_time * 1000 < now
    ) {
      // 超时
      return false;
    }
    if (workInfo.status > 1) {
      // 已提交
      return false;
    } else {
      return true;
    }
  },
  // 题目序号对象
  questionIndexObj: ({ questionList }) => {
    let obj = {};
    questionList.forEach((item, index) => {
      let { question_id } = item;
      obj[question_id] = index;
    });
    return obj;
  },
  // 题目序号对象
  showQuestionIndexObj: (state, { showQuestionList }) => {
    let obj = {};
    showQuestionList.forEach((item, index) => {
      let { question_id } = item;
      obj[question_id] = index;
    });
    return obj;
  },
  // 大题ids
  questionPids: ({ questionList }) => {
    let question_ids = [];
    questionList.forEach((item) => {
      let { question_pid, question_id } = item;
      if (question_pid) {
        if (!question_ids.includes(question_pid)) {
          question_ids.push(question_pid);
        }
      } else {
        question_ids.push(question_id);
      }
    });
    return question_ids;
  },
  errorQuestionPids: ({ errorQuestionList }) => {
    let question_ids = [];
    errorQuestionList.forEach((item) => {
      let { question_pid, question_id } = item;
      if (question_pid) {
        if (!question_ids.includes(question_pid)) {
          question_ids.push(question_pid);
        }
      } else {
        question_ids.push(question_id);
      }
    });
    console.log(question_ids, "question_ids");

    return question_ids;
  },
  // 已答数量
  answeredNum: ({ questionList }) => {
    return questionList.filter((item) => item.is_answer).length;
  },
  // 正确数量
  rightNum: ({ questionList }) => {
    return questionList.filter((item) => item.is_right).length;
  },
  // 子题所在
  questionIndexArr: (state, { showQuestionList }) => {
    let arr = [];
    for (let i = 0; i < showQuestionList.length; i++) {
      if (i === 0) {
        arr.push(0);
      } else {
        let item = showQuestionList[i];
        let preItem = showQuestionList[i - 1];
        if (item.question_pid) {
          if (item.question_pid === preItem.question_pid) {
            arr.push(arr[arr.length - 1]);
          } else {
            arr.push(arr[arr.length - 1] + 1);
          }
        } else {
          arr.push(arr[arr.length - 1] + 1);
        }
      }
    }
    console.log(arr, "arr");

    return arr;
  },
  questionInfo: (
    { activeIndex, questionInfoList },
    { showQuestionList, questionIndexArr, canSubmit }
  ) => {
    if (!showQuestionList.length) return {};
    let pidIndex = questionIndexArr[activeIndex];
    let bigQuestionInfo = questionInfoList[pidIndex];
    let info = {};
    let subIndex = undefined;
    if (bigQuestionInfo.isCompoundQuestion) {
      let id = showQuestionList[activeIndex].question_id;
      subIndex = bigQuestionInfo.child.find((item) => item.id === id).subIndex;
      info = questionInfoList[pidIndex].child[subIndex];
    } else {
      info = questionInfoList[pidIndex];
    }
    info.errorPidIndex = pidIndex;
    info.errorSubIndex = subIndex;
    if (
      info.question_type === QUESTION_TYPE_NAME.MULTIPLE_CHOICE &&
      canSubmit &&
      !window?.localStorage?.getItem("hadShowSwiperGuide")
    ) {
      EventBus.$emit("show-swiper-guide");
      //存储标识
      window?.localStorage?.setItem("hadShowSwiperGuide", true);
    }
    return info;
  },

  //错题列表
  showQuestionList: ({
    questionList,
    showErrorAnalysis,
    errorQuestionList,
  }) => {
    if (showErrorAnalysis) {
      return errorQuestionList;
    } else {
      return questionList;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
